"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHover = exports.body = exports.footer = exports.header = exports.mediaQueryLg = exports.mediaQuery = void 0;
exports.mediaQuery = window.matchMedia("(max-width:768px)");
exports.mediaQueryLg = window.matchMedia("(max-width:1080px)");
exports.header = document.getElementById("header");
exports.footer = document.getElementById("footer");
exports.body = document.querySelector("body");
/**
 * タッチデバイス判定
 */
const isHover = () => {
    return window.matchMedia("(any-hover:hover)").matches;
};
exports.isHover = isHover;
